export default "__VITE_ASSET__CBeLubnX__"